import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { message } from "antd";
import { API_URLS } from "../../api/apiUrls";
import { getApi, putApi } from "../../api/api_instance";
import { ReactComponent as BackIcon } from "../../assets/svgs/back-square.svg";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import Sections from "../StandardFormQuestionBank/Sections";
import SubSectionss from "../StandardFormQuestionBank/SubSections";
import { Badge } from "../../components/Elements/TextStyles/Badge";
import CustomButton from "../../components/Elements/Buttons/CustomButtons";
import Questionss from "../StandardFormQuestionBank/Questions";
import PopupCard from "../../components/Cards/PopupCard/PopupCard";
import SuccessDailogBox from "../../components/Elements/DailogBox/SuccessDailogBox";

const ViewStandardForm = () => {
  const { formId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedSubSection, setSelectedSubSection] = useState(null);
  const [isApproved, setIsApproved] = useState(false);
  const [isApprovedSuccess, setIsApprovedSuccess] = useState(false);
  const [formApproved, setFormApproved] = useState(false);
  const [popup, setPopup] = useState({
    visible: false,
    type: "",
    title: "",
    message: "",
  });

  const showPopup = (type, title, msg) => {
    setPopup({ visible: true, type, title, message: msg });
  };

  useEffect(() => {
    if (popup.visible) {
      const timer = setTimeout(() => {
        setPopup((prev) => ({ ...prev, visible: false }));
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [popup.visible]);

  const handleRequestEdit = async () => {
    try {
      const response = await putApi({
        apiUrl: API_URLS.UPDATE_STANDARD_FORM_STATUS(formId),
        data: {
          status: "Sent for Approval",
          previous_status: "Approved",
        },
      });

      if (response?.success) {
        setFormData((prev) => ({
          ...prev,
          status: "Sent for Approval",
          previous_status: "Approved",
        }));
        showPopup(
          "success",
          "Edit Requested",
          "Edit request sent to manager successfully"
        );
      } else {
        showPopup(
          "error",
          "Request Failed",
          response?.message || "Failed to send request"
        );
      }
    } catch (error) {
      console.error("Error requesting edit", error);
      showPopup("error", "Error", error.message || "Error requesting edit");
    }
  };

  const handleSendForApproval = async () => {
    try {
      const response = await putApi({
        apiUrl: API_URLS.SEND_STANDARD_FORM_FOR_APPROVAL(formId),
      });

      if (response?.success) {
        const isEditApproval = formData?.previous_status === "Approved";
        const newStatus = isEditApproval ? "Draft" : "Approved";
        setIsApproved(newStatus === "Approved");
        setFormData((prev) => ({
          ...prev,
          status: newStatus,
          previous_status: null,
        }));
        showPopup(
          "success",
          isEditApproval ? "Unlocked !!" : "Approved !!",
          isEditApproval ? "Form unlocked for editing" : "Form Approved Successfully"
        );
      } else {
        showPopup(
          "error",
          "Approved Failed",
          response?.message || "Failed to approve form"
        );
      }
    } catch (error) {
      console.error("Error is Approving form", error);
      showPopup("error", "Error", error.message || "Error approving form");
    }
  };

  const handleRejectRequest = async () => {
    try {
      const isEditRequest = formData?.previous_status === "Approved";
      const targetStatus = isEditRequest ? "Approved" : "Draft";
      const response = await putApi({
        apiUrl: API_URLS.UPDATE_STANDARD_FORM_STATUS(formId),
        data: {
          status: targetStatus,
          previous_status: null,
        },
      });

      if (response?.success) {
        setIsApproved(targetStatus === "Approved");
        setFormData((prev) => ({
          ...prev,
          status: targetStatus,
          previous_status: null,
        }));
        showPopup(
          "success",
          "Rejected !!",
          "Request rejected successfully"
        );
      } else {
        showPopup(
          "error",
          "Rejection Failed",
          response?.message || "Failed to reject request"
        );
      }
    } catch (error) {
      console.error("Error rejecting request", error);
      showPopup("error", "Error", error.message || "Error rejecting request");
    }
  };



  const handleStatusChange = async () => {
    try {
      // Fetch sections to verify if there are sections and questions
      const sectionsResponse = await getApi({
        apiUrl: API_URLS.GET_STANDARD_SECTIONSBY_ID(formId),
      });

      if (!sectionsResponse?.success) {
        showPopup(
          "error",
          "Failed",
          sectionsResponse?.message || "Failed to verify form details"
        );
        return;
      }

      const sections = sectionsResponse?.data?.sections || [];
      const totalSections = sectionsResponse?.data?.totalSections || sections.length || 0;

      if (totalSections === 0) {
        showPopup(
          "error",
          "Validation Error",
          "Cannot send for approval. Please add at least one section first."
        );
        return;
      }

      const totalQuestions = sections.reduce(
        (acc, curr) => acc + (curr.totalQuestions || 0),
        0
      );

      if (totalQuestions === 0) {
        showPopup(
          "error",
          "Validation Error",
          "Cannot send for approval. Please add at least one question first."
        );
        return;
      }

      const response = await putApi({
        apiUrl: API_URLS.UPDATE_STANDARD_FORM_STATUS(formId),
        data: {
          status: "Sent for Approval",
        },
      });

      if (response?.success) {
        // message.success("Form sent for approval successfully!");
        setFormData((prev) => ({
          ...prev,
          status: "Sent for Approval",
        }));
        showPopup(
          "success",
          "Approval Sent",
          "Your request is sent for approval successfully"
        );
      } else {
        showPopup(
          "error",
          "Failed",
          response?.message || "Failed to send for approval"
        );
      }
    } catch (error) {
      console.error("Error sending form for approval request", error);
      showPopup(
        "error",
        "Failed to Sent",
        error.message || "Error sending form for approval request"
      );
    }
  };

  const ROLE_TYPE_LABELS = {
    employee: "EMPLOYEE",
    vendor: "VENDOR",
    user: "USER",
    location_user: "LOCATION USER",
    location_admin: "LOCATION ADMIN",
    sub_admin: "SUB ADMIN",
    group_admin: "GROUP ADMIN",
  };

  useEffect(() => {
    const fetchFormDetails = async () => {
      try {
        setLoading(true);
        const response = await getApi({
          apiUrl: API_URLS.GET_STANDARD_FORM_BY_ID(formId),
        });

        if (response?.success && response.data) {
          setFormData(response.data);

          const status = response.data.status?.toLowerCase();
          setIsApproved(status === "approved");
        }
      } catch (error) {
        console.error("Error fetching form data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFormDetails();
  }, [formId]);

  const handleSectionSelect = ({ sectionName, sectionId }) => {
    setSelectedSection({ sectionName, sectionId });
    setSelectedSubSection(null);
  };

  const handleSubSectionSelect = ({ subSectionName, subSectionId }) => {
    setSelectedSubSection({
      subSectionName,
      subSectionId,
      sectionId: selectedSection.sectionId,
    });
  };

  const handleBackToQuestionBank = () => {
    setSelectedSection(null);
    setSelectedSubSection(null);
  };

  const handleBackToSubSections = () => {
    setSelectedSubSection(null);
  };

  return (
    <div style={{ backgroundColor: "#fff" }} className="h-screen px-[20px]">
      <div className="flex justify-end text-xs font-light p-3">
        <p>Home</p>
        <span>/</span>
        <TextStyles color="gradient">Standard Form</TextStyles>
        <span>/</span>
        <TextStyles color="gradient">{formData?.title || "N/A"}</TextStyles>
      </div>

      <div className="flex items-center gap-2 text-xl capitalize font-bold mb-4">
        <BackIcon onClick={() => navigate(-1)} className="cursor-pointer" />
        <span className="capitalize">{formData?.title || "N/A"}</span>
      </div>

      <div
        style={{
          border: "1px solid #3BA2B959",
          borderRadius: "10px",
          paddingTop: "20px",
          boxShadow: "0px 0px 16px 0px #3BA2B91F",
        }}
        className="flex flex-col lg:flex-row lg:items-center justify-between w-full gap-6 px-6 lg:px-10 py-6 mb-6"
      >
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-10 w-full lg:w-auto flex-1">
          <div>
            <span className="font-bold text-[20px]">
              <TextStyles color="gradient">Form Name</TextStyles>
            </span>
            <p className="text-[14px] mt-3 font-bold">
              {formData?.title || "N/A"}
            </p>
          </div>

          <div>
            <span className="font-bold text-[20px]">
              <TextStyles color="gradient">Description</TextStyles>
            </span>
            <p className="text-[14px] font-bold mt-3">
              {formData?.description || "No description available."}
            </p>
          </div>
          <div>
            <span className="font-bold text-[20px]">
              <TextStyles color="gradient">Role Type</TextStyles>
            </span>
            <div className="text-[14px] mt-3 font-bold flex flex-col gap-1">
              {Array.isArray(formData?.role_type) &&
                formData.role_type.length > 0 ? (
                formData.role_type.map((role, index) => (
                  <div key={index}>{ROLE_TYPE_LABELS[role] || role}</div>
                ))
              ) : (
                <div>N/A</div>
              )}
            </div>
          </div>
          <div>
            <span className="font-bold text-[20px] text-center">
              <TextStyles color="gradient">Status</TextStyles>
            </span>
            <div className="mt-3">
              <div className="flex justify-center">
                {" "}
                <Badge text={formData?.status} />{" "}
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-4 w-full lg:w-auto justify-end mt-4 lg:mt-0">
          {(() => {
            const status = formData?.status?.toLowerCase();

            if (status === "inactive") {
              return null;
            }

            if (status === "approved") {
              return (
                <CustomButton
                  buttonType="button"
                  variant="ok"
                  buttonText="Request to Edit"
                  onClick={handleRequestEdit}
                  className="text-[16px] font-normal h-[50px] w-[200px]"
                />
              );
            }

            if (status === "sent for approval") {
              const isEditRequest = formData?.previous_status === "Approved";
              return (
                <div className="flex flex-wrap gap-4 justify-end w-full lg:w-auto">
                  <CustomButton
                    buttonType="button"
                    variant="ok"
                    buttonText={isEditRequest ? "Approve Edit Request" : "Approve and Publish"}
                    onClick={handleSendForApproval}
                    className="text-[16px] font-normal h-[50px] w-[200px]"
                  />
                  <CustomButton
                    buttonType="button"
                    variant="cancel"
                    buttonText="Reject"
                    onClick={handleRejectRequest}
                    className="text-[16px] font-normal h-[50px] w-[200px]"
                  />
                </div>
              );
            }

            if (status === "draft") {
              return (
                <CustomButton
                  buttonType="button"
                  variant="ok"
                  buttonText="Send for Approval"
                  onClick={handleStatusChange}
                  className="text-[16px] font-normal h-[50px] w-[200px]"
                />
              );
            }

            return null;
          })()}
        </div>
      </div>

      <div>
        {!selectedSection ? (
          <Sections formId={formId} approved={isApproved} onSectionSelect={handleSectionSelect} />
        ) : !selectedSubSection ? (
          <SubSectionss
            formId={formId}
            sectionName={selectedSection.sectionName}
             approved={isApproved} 
            sectionId={selectedSection.sectionId}
            onBack={handleBackToQuestionBank}
            onSubSectionSelect={handleSubSectionSelect}
          />
        ) : (
          <Questionss
            formId={formId}
            sectionId={selectedSection.sectionId}
             approved={isApproved} 
            subSectionId={selectedSubSection.subSectionId}
            sectionName={selectedSection.sectionName}
            subSectionName={selectedSubSection.subSectionName}
          />
        )}
      </div>
      
      {isApprovedSuccess && (
        <SuccessDailogBox
          onOpen={isApprovedSuccess}
          onClose={() => setIsApprovedSuccess(false)}
          popuptype="approved"
          successMessage={"You Requests is sent for Approval"}
        />
      )}

      {/* {formApproved && (
        <SuccessDailogBox
          onOpen={formApproved}
          onClose={() => setFormApproved(false)}
          popuptype="approved"
          successMessage={"Form Approved Successfully"}
        />
      )} */}

      {popup.visible && (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
          <PopupCard
            type={popup.type}
            title={popup.title}
            message={popup.message}
          />
        </div>
      )}
    </div>
  );
};

export default ViewStandardForm;
